module.exports = __webpack_public_path__ + "static/media/icon_microwave.ce9f2a84.svg";